<div class="custom-question-container">

    <div class="custom-question-block">
        <div class="custom-question-header">
            <div class="custom-question-title">{{ 'bikeshop.workshop.jobcard.custom-question.linked_service_questions' | translate }}
            </div>
            <hub-button [icon]="'arrow-up-right'" [style]="'borderless'" [size]="'lg'"
                (buttonClick)="showCustomQuestonDetails()"></hub-button>
        </div>
        <div class="custom-question-metric">
            <span class="value">{{getCompletedCustomQuestions()}}</span>
            <span class="value">/</span>
            <span class="value">{{getCustomQuestionCount()}}</span>
            <span class="text">{{'bikeshop.workshop.jobcard.checklist.complete' | translate }}</span>
        </div>
    </div>

</div>